import { useMemo } from 'react';

import { toSet } from '../permissions/permissionsStore';
import { satisfiesRequirement } from '../permissions/permissionsMatch';
import { usePermissions } from '../permissions/permissionsStore';
import { TPermissionRequirement } from '../types';

export function useCan(req: TPermissionRequirement) {
  const query = usePermissions({ enabled: true });
  const { data = [], isLoading } = query;
  const grantedSet = useMemo(() => toSet(data), [data]);
  const allowed = useMemo(
    () => !isLoading && satisfiesRequirement(req, grantedSet),
    [isLoading, req, grantedSet]
  );
  return { allowed, isLoading };
}
